import { DateTime } from "luxon";
import {
  FucntionCreateDateOfWeeK,
  FunctionCreateDay,
  FunctionCreateDayPlusOne,
  FunctionCreateHour,
  FunctionCreateTimeNow,
  FunctionCreateTimeNowPlusOne,
} from "../../../utils/useFunction";
import { LAST_TIME_YOU_STILL_CAN_BOOK } from "../../../utils/useConstants";

export const THIS_TIME_IN_N_OUT = "08.00 - 17.00";

export const ARRAY_DATE = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

export const ARRAY_DATE_WEEK = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

export const ARRAY_DATE_WEEK_TH = [
  "วันอาทิตย์",
  "วันจันทร์",
  "วันอังคาร",
  "วันพุธ",
  "วันพฤหัสบดี",
  "วันศุกร์",
  "วันเสาร์",
  "วันอาทิตย์",
];

export const MAPPING_DATE = {
  Sunday: "วันอาทิตย์",
  Monday: "วันจันทร์",
  Tuesday: "วันอังคาร",
  Wednesday: "วันพุธ",
  Thursday: "วันพฤหัสบดี",
  Friday: "วันศุกร์",
  Saturday: "วันเสาร์",
};

export const createPresentObject = FunctionCreateTimeNow()
  .slice(0, 10)
  .split("-");

export const createPresentObjectPlustOne = FunctionCreateTimeNowPlusOne()
  .slice(0, 10)
  .split("-");

export const createPresent =
  String(Number(createPresentObject[1])) +
  "." +
  String(Number(createPresentObject[2])) +
  "." +
  String(Number(createPresentObject[0]));

export const createPresentPlustOne =
  String(Number(createPresentObjectPlustOne[1])) +
  "." +
  String(Number(createPresentObjectPlustOne[2])) +
  "." +
  String(Number(createPresentObjectPlustOne[0]));

// export const createPresentStringDate = ARRAY_DATE[new Date().getUTCDay(7)];
export const createPresentStringDate = ARRAY_DATE[FucntionCreateDateOfWeeK()];

export const HOW_MANY_FUTURE = 6;

export const BusketGenerateDate = (calendars) => {
  let present =
    FunctionCreateHour() >= LAST_TIME_YOU_STILL_CAN_BOOK
      ? FunctionCreateDayPlusOne()
      : FunctionCreateDay();

  // const thisDate = new Date(startFrom)
  //   .toLocaleDateString("en-US")
  //   .replaceAll("/", ".");

  // !(o?.day === FunctionCreateDay() && FunctionCreateHour() > 19);

  // const TimePlusOneDay = DateTime.fromMillis(startFrom)
  //   .plus({ days: 1 })
  //   .toLocaleString({
  //     month: "2-digit",
  //     day: "2-digit",
  //     year: "numeric",
  //   })
  //   .split("/");

  // const thisDate =
  //   FunctionCreateHour() > 19
  //     ? new Date(startFrom).toLocaleDateString("en-US").replaceAll("/", ".")
  //     : `${Number(TimePlusOneDay[0])}.${Number(TimePlusOneDay[1])}.${Number(
  //         TimePlusOneDay[2]
  //       )}`;

  // console.log("thisDate", {
  //   thisDate,
  //   startFrom,
  //   c: new Date(startFrom),
  //   cc: DateTime.fromMillis(startFrom),
  //   ccc: TimePlusOneDay.toLocaleString({
  //     month: "2-digit",
  //     day: "2-digit",
  //     year: "numeric",
  //   }).replaceAll("/", "."),
  //   cccc: `${Number(TimePlusOneDay[0])}.${Number(TimePlusOneDay[1])}.${Number(
  //     TimePlusOneDay[2]
  //   )}`,
  // });

  let will_show_how_many_future = HOW_MANY_FUTURE;

  let createPast = new Array(present)
    .fill("")
    .map((_, i) => {
      const thisTime = DateTime.now()
        .setLocale("th")
        .setZone("UTC+7")
        .startOf("day")
        .minus({ days: i + 1 })
        .toISO()
        .slice(0, 10)
        .split("-");

      return `${
        Number(thisTime[1]) +
        "." +
        Number(thisTime[2]) +
        "." +
        Number(thisTime[0])
      }`;
      // return
      //  moment()
      //   .subtract(i + 1, "days")
      //   ._d.toLocaleDateString("en-US")
      //   .replaceAll("/", ".");
    })
    .reverse();

  let createFuture = new Array(will_show_how_many_future)
    .fill("")
    .map((_, i) => {
      const thisTime = DateTime.now()
        .setLocale("th")
        .setZone("UTC+7")
        .startOf("day")
        .plus({ days: i + 1 })
        .toISO()
        .slice(0, 10)
        .split("-");

      return `${
        Number(thisTime[1]) +
        "." +
        Number(thisTime[2]) +
        "." +
        Number(thisTime[0])
      }`;
    });

  let createFuturePlusOne = new Array(will_show_how_many_future)
    .fill("")
    .map((_, i) => {
      const thisTime = DateTime.now()

        .setLocale("th")
        .setZone("UTC+7")
        .startOf("day")
        .plus({ days: i + 2 })
        .toISO()
        .slice(0, 10)
        .split("-");
      return `${
        Number(thisTime[1]) +
        "." +
        Number(thisTime[2]) +
        "." +
        Number(thisTime[0])
      }`;
    });

  // .map((_, i) => {
  //   return moment()
  //     .add(i + 1, "days")
  //     ._d.toLocaleDateString("en-US")
  //     .replaceAll("/", ".");
  // });

  let thisWeek = [];

  if (present === FunctionCreateDay()) {
    thisWeek = [...createPast, createPresent, ...createFuture];
  } else {
    thisWeek = [...createPast, createPresentPlustOne, ...createFuturePlusOne];
  }

  //  thisWeek = [
  //   ...createPast,
  //   present === FunctionCreateDay() ? createPresent : createPresentPlustOne,
  //   ...createFuture,
  // ];

  const result = thisWeek.map((date, index) => {
    const findSelf = calendars.find((o) => o?.showDate === date);

    const ios_bug_format = date?.replaceAll(".", "/");
    const objectDate = new Date(ios_bug_format);

    const res = {
      date: date,
      month: Number(date.split(".")[0]),
      name: ARRAY_DATE[objectDate.getDay()],
      disabled:
        findSelf?.status === true
          ? true
          : false ||
            (findSelf?.season_mix_planned - findSelf?.season_mix_booked > 0
              ? false
              : true),
      filter: index < present,
      day: Number(date.split(".")[1]),
      year: Number(date.split(".")[2]),
      time: new Date(ios_bug_format).getTime(),
    };

    return res;
  });

  const returnData = result?.filter((o) => {
    return !o.filter;
  });

  return returnData;
};

export const BusketGenerateFutureDate = (
  isReturn = false,
  startFrom,
  calendars
) => {
  if (startFrom) {
    let present = FunctionCreateDay();
    // let will_show_how_many_future = HOW_MANY_FUTURE;

    // let createPast = new Array(present)
    //   .fill("")
    //   .map((_, i) => {
    //     return moment(startFrom)
    //       .subtract(i + 1, "days")
    //       ._d.toLocaleDateString("en-US")
    //       .replaceAll("/", ".");
    //   })
    //   .reverse();

    let createPast = new Array(present)
      .fill("")
      .map((_, i) => {
        const thisTime = DateTime.fromMillis(startFrom)
          .setLocale("th")
          .setZone("UTC+7")
          .startOf("day")
          .minus({ days: i + 1 })
          .toISO()
          .slice(0, 10)
          .split("-");

        return `${
          Number(thisTime[1]) +
          "." +
          Number(thisTime[2]) +
          "." +
          Number(thisTime[0])
        }`;
      })
      .reverse();

    const thisDate = new Date(startFrom)
      .toLocaleDateString("en-US")
      .replaceAll("/", ".");

    let createFuture = new Array(40 - present)
      .fill("")
      .map((_, i) => {
        const thisTime = DateTime.fromMillis(startFrom)
          .setLocale("th")
          .setZone("UTC+7")
          .startOf("day")
          .plus({ days: i + 1 })
          .toISO()
          .slice(0, 10)
          .split("-");

        return `${
          Number(thisTime[1]) +
          "." +
          Number(thisTime[2]) +
          "." +
          Number(thisTime[0])
        }`;
      })
      .filter((o) => {
        return o !== thisDate;
      })
      .slice(0, HOW_MANY_FUTURE);

    const thisWeek = [...createPast, thisDate, ...createFuture];

    const result = thisWeek.map((date, index) => {
      const findSelf = calendars.find((o) => o?.showDate === date);

      const ios_bug_format = date?.replaceAll(".", "/");
      const objectDate = new Date(ios_bug_format);
      return {
        date: date,
        month: Number(date.split(".")[0]),
        name: ARRAY_DATE[objectDate.getDay()],
        disabled: findSelf?.status === true ? true : false,
        filter: index < present,
        day: Number(date.split(".")[1]),
        year: Number(date.split(".")[2]),
        time: new Date(ios_bug_format).getTime(),
      };
    });
    // console.log("thisWeek ", {
    //   thisWeek,
    //   createPast,
    //   createFuture,
    //   thisDate,
    //   result,
    //   check: DateTime.fromMillis(startFrom),
    // });

    const returnData = result?.filter((o) => {
      return !o.filter;
    });

    return returnData;
  } else {
    return BusketGenerateDate(calendars);
  }
};
